export default {
    data() {
        return {
            valid: {
                inventory: false,
                name: false,
                description: false,
                price: false,
                sku_number: false,
                attribute_option_ids: false,
            },
            success: {
                inventory: false,
                name: false,
                description: false,
                sellingPrice: false,
                price: false,
                sku_number: false,
                attribute_option_ids: false,
            },
            error: {
                inventory: "",
                name: "",
                description: "",
                price: "",
                sku_number: "",
                attribute_option_ids: "",
            },
            errorMessages: {
          
                nameRequired: {
                    el: "Το όνομα είναι υποχρεωτικό",
                    en: "Name is required",
                    it: "Il nome è obbligatorio"
                },
                descriptionRequired: {
                    el: "Απαιτείται περιγραφή",
                    en: "Description is required",
                    it: "La descrizione è necessaria"
                },
                priceMin: {
                    el: "Η τιμή πρέπει να είναι τουλάχιστον 0,1",
                    en: "Price must be minimum 0.1",
                    it: "Il prezzo deve essere minimo 0,1"
                },
                
                inventory: {
                    el: "Απαιτείται απογραφή",
                    en: "Inventory is required",
                    it: "L'inventario è necessario"
                },
                sku_number: {
                    el: "Απαιτείται αριθμός SKU",
                    en: "SKU number is required",
                    it: "È richiesto il numero di SKU"
                },
                attributes: {
                    el: "Απαιτούνται χαρακτηριστικά",
                    en: "Attributes are required",
                    it: "Gli attributi sono richiesti"
                },
            }
        };
    },

    computed: {
        formValid() {
            return (
                this.valid.name &&
                this.valid.description &&
                this.valid.price &&
                this.valid.sku_number &&
                this.valid.inventory &&
                this.valid.attribute_option_ids
            );
        }
    },

    methods: {

        validateName() {
            if (this.productLang === "el") {
                if (!this.variant.name["el"]) {
                    this.error.name = this.errorMessages.nameRequired[
                        this.lang
                    ];
                } else {
                    this.error.name = "";
                }
            }
        },

        validateDescription() {
            if (this.descriptionLang === "el") {
                if (!this.variant.description["el"]) {
                    this.error.description = this.errorMessages.descriptionRequired[
                        this.lang
                    ];
                } else {
                    this.error.description = "";
                }
            }
        },


        validatePrice() {
            if (Number(this.variant.price) > 0) {
                this.error.price = "";
            } else {
                this.error.price = this.errorMessages.priceMin[
                    this.lang
                ];
            }
        },

        validateSku() {
            if (!this.variant.sku_number) {
                this.error.sku_number = this.errorMessages.sku_number[
                    this.lang
                ];
            } else {
                this.error.sku_number = "";
            }
        },

        validateInventory() {
            if (!(Number(this.variant.inventory) > 0)) {
                this.error.inventory = this.errorMessages.inventory[
                    this.lang
                ];
            } else {
                this.error.inventory = "";
            }
        },

        validateAttributes() {
            if (!this.variant?.attribute_option_ids?.length) {
                this.error.attribute_option_ids = this.errorMessages.attributes[
                    this.lang
                ];
            } else {
                this.error.attributes = "";
            }
        },
    },

    watch: {

        variantLang(val) {
            if (val === "en" || val === "it") {
                this.error.name = "";
            }
        },

        descriptionLang(val) {
            if (val === "en" || val === "it") {
                this.error.description = "";
            }
        },

        ["variant.name.el"]: {
            immediate: true,
            handler(val) {
                this.valid.name = !!val;
                this.success.name = !!val;
            }
        },

        ["variant.description.el"]: {
            immediate: true,
            handler(val) {
                this.valid.description = !!val;
                this.success.description = !!val;
            }
        },

        ["variant.price"]: {
            immediate: true,
            handler(val) {
                this.valid.price = val >= 0.1;
                this.success.price = val >= 0.1;
            }
        },

        ["variant.attribute_option_ids"]: {
            immediate: true,
            handler(val) {
                // this.validateAttributes();
                this.valid.price = !!val.length;
                this.success.price = !!val.length;
            }
        },

        ["variant.sku_number"]: {
            immediate: true,
            handler(val) {
                this.valid.sku_number = !!val;
                this.success.sku_number = !!val;
            }
        },

        ["variant.inventory"]: {
            immediate: true,
            handler(val) {
                this.valid.inventory = !!val;
                this.success.inventory = !!val;
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    inventory: false,
                    name: false,
                    description: false,
                    price: false,
                    sku_number: false,
                    attribute_option_ids: false,
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        inventory: "",
                        name: "",
                        description: "",
                        price: "",
                        sku_number: "",
                        attribute_option_ids: "",
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
